import React, { useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import useApi from "../../hooks/useApi";
import { useAuth } from "../../context/authContext";
import { useThemeContext } from "../../context/themeContext";
import { ReactComponent as EmptyIconDark } from "../../assets/IconEmptyDark.svg";
import { ReactComponent as EmptyIconLight } from "../../assets/IconEmptyLight.svg";
import ReleaseEntry from "./ReleaseEntry";
import LayoutWithHeader from "../../components/LayoutWithHeader";

function WhatsNew() {
  const { getWhatsNewFeed, markNotificationsRead } = useApi();
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const { mode } = useThemeContext();

  const { data, isLoading } = useQuery({
    queryKey: ["whatsNew", "feed"],
    queryFn: getWhatsNewFeed,
    refetchOnMount: "always",
  });

  // Mark all whats_new notifications as read and clear the sidebar dot
  const markRead = useMutation({
    mutationFn: () => markNotificationsRead({ kind: "whats_new" }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["notifications", "unreadCount", "whats_new"],
      }),
  });

  useEffect(() => {
    if (user) markRead.mutate();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LayoutWithHeader title={"What's New"}>
      <Box>
        {isLoading && (
          <>
            {[...Array(3)].map((_, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={120}
                sx={{ mb: 2, borderRadius: 1 }}
              />
            ))}
          </>
        )}

        {data?.feed?.map((entry) => (
          <ReleaseEntry key={entry.id} entry={entry} />
        ))}

        {!isLoading && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 4,
              gap: 1,
            }}
          >
            {mode === "dark" ? (
              <EmptyIconDark width={100} />
            ) : (
              <EmptyIconLight width={100} />
            )}
            <Typography variant="body2" color="text.secondary">
              {data?.feed?.length
                ? "You're all caught up"
                : "Nothing to show here"}
            </Typography>
          </Box>
        )}
      </Box>
    </LayoutWithHeader>
  );
}

export default WhatsNew;
